import styles from './CheckUp.module.css' ;

function CheckUp() {
  return (
    <div className={styles.CheckUp}>
      CheckUp
    </div>
  )
}

export default CheckUp
